import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export const downloadZip = async (
  fileName: string,
  files: { name: string; data: string }[]
) => {
  const zip = new JSZip();
  const rootFolder = zip.folder(fileName);

  if (!rootFolder) return;

  files.forEach(({ name, data }) => {
    rootFolder.file(name, data);
  });

  const blob = await zip.generateAsync({ type: 'blob' });
  saveAs(blob, `${fileName}.zip`);
};
